var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kanban-board" },
    [
      _vm.groupValue && _vm.groupValue.fieldId
        ? _vm._l(_vm.groupedKanbanData, function (groupItem, gIndex) {
            return _c(
              "div",
              {
                key: "kanban-group-" + gIndex,
                staticClass: "kanban-group-wrapper",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "kanban-group-header",
                    on: {
                      click: function ($event) {
                        return _vm.toggleGroupCollapse(gIndex)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons group-icon" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.isGroupCollapsed(gIndex)
                              ? "chevron_right"
                              : "expand_more"
                          ) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "group-label" }, [
                      _vm._v(
                        _vm._s(groupItem.key) +
                          " (" +
                          _vm._s(groupItem.records.length) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "knbn-group-summary-container" },
                      [
                        _c("KanbanSummary", {
                          attrs: {
                            records: groupItem.records,
                            selectedField: _vm.kanbanSettings.kanbanField,
                            kanbanField: _vm.getFieldObject(
                              _vm.kanbanSettings.kanbanField
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "collapse" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isGroupCollapsed(gIndex),
                          expression: "!isGroupCollapsed(gIndex)",
                        },
                      ],
                      staticClass: "kanban-group-content",
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "columns-container",
                          attrs: {
                            list: _vm.buildColumnsForGroup(
                              _vm.columns,
                              groupItem.records
                            ),
                            options: _vm.kanbanColumnDragOptions,
                          },
                          on: { end: _vm.onColumnOrderChange },
                        },
                        [
                          _c(
                            "transition-group",
                            {
                              staticClass: "columns-wrapper",
                              attrs: { tag: "div" },
                            },
                            _vm._l(
                              _vm.buildColumnsForGroup(
                                _vm.columns,
                                groupItem.records
                              ),
                              function (column, colIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: _vm.columnKey(column, colIndex),
                                    staticClass: "kanban-column",
                                    style: _vm.getColumnStyles(column._id),
                                    attrs: {
                                      "data-id": column._id,
                                      "data-index": colIndex,
                                      "data-label": column.label,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "kanban-column-header",
                                        style: _vm.getColumnHeaderStyles(
                                          column._id
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(column.label) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "draggable",
                                      {
                                        staticClass: "kanban-column-body",
                                        attrs: {
                                          options: _vm.kanbanCardDragOptions,
                                        },
                                        on: {
                                          end: function ($event) {
                                            return _vm.onCardDrop(
                                              colIndex,
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: column.records,
                                          callback: function ($$v) {
                                            _vm.$set(column, "records", $$v)
                                          },
                                          expression: "column.records",
                                        },
                                      },
                                      [
                                        _c(
                                          "transition-group",
                                          {
                                            staticClass:
                                              "kanban-cards-container",
                                            attrs: {
                                              tag: "div",
                                              "data-column-id": column._id,
                                              "data-column-index": colIndex,
                                            },
                                          },
                                          _vm._l(
                                            column.records,
                                            function (record, recIndex) {
                                              return _c("KanbanRecordCard", {
                                                key: _vm.recordKey(
                                                  record,
                                                  recIndex
                                                ),
                                                attrs: {
                                                  record: record,
                                                  recordIndex: recIndex,
                                                  columnId: column._id,
                                                  columnIndex: colIndex,
                                                  "card-fields":
                                                    _vm.kanbanSettings
                                                      .cardFields,
                                                  table: _vm.table,
                                                  selectedRecords:
                                                    _vm.selectedRecords,
                                                  isSelected: _vm.isSelected(
                                                    record._id
                                                  ),
                                                  isHovered:
                                                    _vm.recordHover ===
                                                    record._id,
                                                  getRecordColor:
                                                    _vm.getRecordColor,
                                                },
                                                on: {
                                                  hover: function (val) {
                                                    _vm.recordHover = val
                                                  },
                                                  "toggle-selection":
                                                    _vm.toggleSelection,
                                                  "card-click": _vm.onCardClick,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          })
        : [
            _c(
              "draggable",
              {
                staticClass: "columns-container",
                attrs: { options: _vm.kanbanColumnDragOptions },
                on: { end: _vm.onColumnOrderChange },
                model: {
                  value: _vm.columns,
                  callback: function ($$v) {
                    _vm.columns = $$v
                  },
                  expression: "columns",
                },
              },
              [
                _c(
                  "transition-group",
                  { staticClass: "columns-wrapper", attrs: { tag: "div" } },
                  _vm._l(_vm.columns, function (column, colIndex) {
                    return _c(
                      "div",
                      {
                        key: _vm.columnKey(column, colIndex),
                        staticClass: "kanban-column",
                        style: _vm.getColumnStyles(column._id),
                        attrs: {
                          "data-id": column._id,
                          "data-index": colIndex,
                          "data-label": column.label,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "kanban-column-header",
                            style: _vm.getColumnHeaderStyles(column._id),
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(column.label) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "draggable",
                          {
                            staticClass: "kanban-column-body",
                            attrs: { options: _vm.kanbanCardDragOptions },
                            on: {
                              end: function ($event) {
                                return _vm.onCardDrop(colIndex, $event)
                              },
                            },
                            model: {
                              value: column.records,
                              callback: function ($$v) {
                                _vm.$set(column, "records", $$v)
                              },
                              expression: "column.records",
                            },
                          },
                          [
                            _c(
                              "transition-group",
                              {
                                staticClass: "kanban-cards-container",
                                attrs: {
                                  tag: "div",
                                  "data-column-id": column._id,
                                  "data-column-index": colIndex,
                                },
                              },
                              _vm._l(
                                column.records,
                                function (record, recIndex) {
                                  return _c("KanbanRecordCard", {
                                    key: _vm.recordKey(record, recIndex),
                                    attrs: {
                                      record: record,
                                      "record-index": recIndex,
                                      "column-id": column._id,
                                      "column-index": colIndex,
                                      "is-selected": _vm.isSelected(record._id),
                                      "is-hovered":
                                        _vm.recordHover === record._id,
                                      "card-fields":
                                        _vm.kanbanSettings.cardFields,
                                      table: _vm.table,
                                      getRecordColor: _vm.getRecordColor,
                                    },
                                    on: {
                                      hover: function ($event) {
                                        _vm.recordHover = $event
                                      },
                                      "card-click": _vm.onCardClick,
                                      "toggle-selection": _vm.toggleSelection,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }